<template>
  <public-layout>
    <section class="hero lvl2">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">
            <div class="column">
              <p class="product-title">
                Teacher's Manual
              </p>
              <p class="product-subtitle">
                Access to over 1000 lessons, 200 story time readings, 120 circle time activities, 60 circle time songs and much more!
              </p>
              <p class="product-description">
                A comprehensive early education package combining global and local content, and curricular goals. Designed to support teachers to promote physical,
                 social and emotional skills in young children. Structured in the selected subjects of Mathematics, Language & Communication, Arts & Crafts, Environmental Education, Physical Education and Music.
                  Empowers each child to be an active participant in creating their own future.
              </p>
              <p class="product-cta">
                <router-link class="button button-large button-secondary" :to="{ name: 'kinder' }">Go Back</router-link>
              </p>
            </div>
            <div class="column is-narrow">
              <img class="product-image" src="/static/img/assets/teacher-manual.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>

    <hr>

    <section class="section course-info is-left-aligned">
      <div class="container">
        <div class="columns">
          <div class="column is-6">
            <figure class="image">
              <img src="/static/img/assets/infograph-teachers-manual.png" alt="">
            </figure>
          </div>
          <div class="column is-6">
            <h2 class="section-title">Putting the overall well-being of every child first!</h2>
            <p class="content">
              Uniquely designed for preschoolers between the ages 2.5 – 6.5 years. Integrates eight designated exploration areas.
               Inspires children to explore, experiment and practice following a safe routine.
              <ul>
                <li>Promotes informal and independent learning through free play and play-based activities that are FUN!</li>
                <li>Personalised for children needing extra practice, a different approach or interested in advancing more in order to boost motivation.</li>
                <li>Enables teachers to blend the local language, culture and needs to complement the global content in a natural way.</li>
                <li>Strikes a healthy balance between rest, work, and play.</li>
              </ul>
              <br>
              <a class="button button-large button-primary" href="/static/FunAcademyManualSneakPeek.pdf" target="_blank">Download a free sample of the Teacher’s Manual</a>
            </p>
          </div>
        </div>
      </div>
    </section>

  </public-layout>
</template>

<script>
import PublicLayout from '@/layouts/PublicLayout'
import SectionContact from '@/components/SectionContact'
import Button from '@/components/Button'

export default {
  name: 'kinderpage',

  components: {
    PublicLayout,
    SectionContact,
    Button
  },

  created () {},

  data () {
    return {}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/ManualPage.vue